var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSort = function SvgSort(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M5.674 9h8.652c.6 0 .9-.639.476-1.012l-4.326-3.814a.74.74 0 0 0-.952 0L5.198 7.988C4.775 8.36 5.075 9 5.674 9m-.37 2.072a.6.6 0 0 1 .359-.067h8.674a.59.59 0 0 1 .607.332.58.58 0 0 1-.132.678l-4.335 3.812a.74.74 0 0 1-.954 0l-4.335-3.812a.585.585 0 0 1 .117-.943",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSort);
export default ForwardRef;